import React from "react";

function Warranty() {
    return (
        <>
            <h1>TODO!!!</h1>
        </>
    );
}

export default Warranty;